export class Cycler {
  /*
   * @param {*[]} items
   */
  constructor (items) {
    /**
     * @type {*[]}
     * @private
     */
    this.items = items

    /**
     * @type {number}
     * @private
     */
    this.currentPosition = 0
  }

  /**
   * @returns {*}
   */
  get current () {
    return this.items[this.currentPosition]
  }

  /**
   * @param {number} val - The new position we want the array to be sat at
   *
   * @returns {undefined}
   */
  set (val) {
    this.currentPosition = val
  }

  /**
   * @returns {*}
   */
  prev () {
    this.currentPosition = this.currentPosition - 1

    if (this.currentPosition < 0) this.currentPosition = this.items.length - 1

    return this.current
  }

  /**
   * @returns {*}
   */
  next () {
    this.currentPosition = (this.currentPosition + 1) % this.items.length

    return this.current
  }
}
